import {ParameterStore} from './ParameterStore';

const evalsameOwnerNoGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.sameOwner.value == false;
};
const evalsameOwnerNoAndFGGuard = (parameterStore: ParameterStore) => {
    return (
        parameterStore.approval.sameOwner.value == false &&
        parameterStore.approval.agentProducts.value.includes('FGPathsetterIUL')
    );
};
const evalsameOwnerNoAndFGOrMOOGuard = (parameterStore: ParameterStore) => {
    return (
        parameterStore.approval.sameOwner.value == false &&
        ['FGPathsetterIUL', 'MOOIULE'].some((value) => parameterStore.approval.agentProducts.value.includes(value))
    );
};
const evalsameOwnerNoAndLSWOrFGGuard = (parameterStore: ParameterStore) => {
    return (
        parameterStore.approval.sameOwner.value == false &&
        (['LSWIUL', 'FGPathsetterIUL'].some((value) => parameterStore.approval.agentProducts.value.includes(value)) ||
            parameterStore.approval.agentProducts.value.length == 0)
    );
};
const evalcurrentlyEmployedEmployedGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Employed';
};
const evalprevEmployedGuard = (parameterStore: ParameterStore) => {
    const approval = parameterStore.approval;
    return (
        evalcurrentlyEmployedEmployedGuard(parameterStore) &&
        approval.employmentDays.value != '' &&
        (approval.employmentDays.value < 186 || approval.timeEmployed.value <= 0.5)
    );
};
const evalcurrentlyEmployedUnemployedGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Unemployed';
};
const evalcurrentlyEmployedRetiredGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Retired';
};
const evalcurrentlyEmployedStudentGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Student';
};
const evalcurrentlyEmployedDisabilityGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Disability';
};
const evalcurrentlyEmployedOtherGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.currentlyEmployed.value == 'Other';
};
const evalusCitizenshipPermanentResidentGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.usCitizenship.value == 'PermanentResident';
};
const evalusCitizenshipUSVisaHolderGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.usCitizenship.value == 'USVisaHolder';
};
const evalusCitizenshipNoUSVisaTINonlyGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.usCitizenship.value == 'NoUSVisaTINonly';
};
const evalvalidDriversLicenseNoIDGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.validDriversLicense.value == 'NoID';
};
const evalvalidDriversLicenseYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.validDriversLicense.value == 'Yes';
};
const evalvalidDriversLicenseStateIDGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.validDriversLicense.value == 'StateID';
};
const evalvalidDriversLicenseNotYesGuard = (parameterStore: ParameterStore) => {
    const approval = parameterStore.approval;
    return ['StateID', 'NoIDApplicantisaMinor', 'NoID'].includes(approval.validDriversLicense.value);
};
const evalmilitaryYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.military.value == 'Yes';
};
const evalnumberOfBenesGt1Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.numberOfBenes.value > 1;
};
const evalnumberOfBenesGt2Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.numberOfBenes.value > 2;
};
const evalnumberOfBenesGt3Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.numberOfBenes.value > 3;
};
const evalnumberOfBenesGt4Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.numberOfBenes.value > 4;
};
const evalnumberOfBenesGt5Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.numberOfBenes.value > 5;
};
const evalbeneTotalPctGuard = (parameterStore: ParameterStore) => {
    const approval = parameterStore.approval;
    return (
        approval.benePercent1.value +
            approval.benePercent2.value +
            approval.benePercent3.value +
            approval.benePercent4.value +
            approval.benePercent5.value +
            approval.benePercent6.value !=
        100
    );
};
const evalcontBeneYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.contBene.value == 'Yes';
};
const evalcalculatedContNumberOfBenesGt1Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.calculatedContNumberOfBenes.value > 1;
};
const evalcalculatedContNumberOfBenesGt2Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.calculatedContNumberOfBenes.value > 2;
};
const evalcalculatedContNumberOfBenesGt3Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.calculatedContNumberOfBenes.value > 3;
};
const evalcalculatedContNumberOfBenesGt4Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.calculatedContNumberOfBenes.value > 4;
};
const evalcalculatedContNumberOfBenesGt5Guard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.calculatedContNumberOfBenes.value > 5;
};
const evalcontBeneTotalPctGuard = (parameterStore: ParameterStore) => {
    const approval = parameterStore.approval;
    return (
        approval.contBenePercent1.value +
            approval.contBenePercent2.value +
            approval.contBenePercent3.value +
            approval.contBenePercent4.value +
            approval.contBenePercent5.value +
            approval.contBenePercent6.value !=
            100 && approval.contBene.value == 'Yes'
    );
};
const evalexistingCoverageYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.existingCoverage.value as boolean;
};
const evalshoppedCoverageYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.shoppedCoverage.value == 'Yes';
};
const evalDrugorAlcoholDependenceWithdrawalGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.DrugorAlcoholDependenceWithdrawal.value as boolean;
};
const evalDrugorAlcoholDependenceWithdrawalANDtakingMedicineDueToDrugGuard = (parameterStore: ParameterStore) => {
    return (
        evalDrugorAlcoholDependenceWithdrawalGuard(parameterStore) &&
        parameterStore.approval.takingMedicineDueToDrug.value
    );
};
const evalDUIGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.DUI.value as boolean;
};
const evalLicenseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.License.value as boolean;
};
const evalMovingviolationsGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.Movingviolations.value as boolean;
};
const evalCriminaloffenseGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.Criminaloffense.value as boolean;
};
const evalCriminaloffenseANDcriminalOffenseIncarceratedGuard = (parameterStore: ParameterStore) => {
    return evalCriminaloffenseGuard(parameterStore) && parameterStore.approval.criminalOffenseIncarcerated.value;
};
const evalBankruptcyGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.Bankruptcy.value as boolean;
};
const evalBankruptcyANDNotbankruptcyOpenGuard = (parameterStore: ParameterStore) => {
    return evalBankruptcyGuard(parameterStore) && !parameterStore.approval.bankruptcyOpen.value;
};
const evalbankruptcyMultipleGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.bankruptcyMultiple.value as boolean;
};
const evalextremeSportsYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.extremeSports.value == 'Yes';
};
const evalextremeSportsScubaDivingGuard = (parameterStore: ParameterStore) => {
    return (
        evalextremeSportsYesGuard(parameterStore) &&
        parameterStore.approval.extremeSportsOptions.value.includes('ScubaDiving')
    );
};
const evalTobaccoRatingYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.TobaccoRating.value == 'Yes';
};
const evalMarijuanaRatingGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.MarijuanaRating.value as boolean;
};
const evalOtherRatingGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.OtherRating.value as boolean;
};
const evalfatherLivingYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.fatherLiving.value == 'Yes';
};
const evalfatherLivingNoGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.fatherLiving.value == 'No';
};
const evalfatherLivingUnknownGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.fatherLiving.value == 'Unknown';
};
const evalmotherLivingYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.motherLiving.value == 'Yes';
};
const evalmotherLivingNoGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.motherLiving.value == 'No';
};
const evalmotherLivingUnknownGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.motherLiving.value == 'Unknown';
};
const evalbiologicalFamilyConditionGuard = (parameterStore: ParameterStore) => {
    return ['Cancer', 'HeartDisease', 'Diabetes', 'Stroke'].some((c) =>
        parameterStore.approval.biologicalFamilyCondition.value.includes(c),
    );
};
const evalbiologicalFamilyConditionFatherGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionWhichMember.value.includes('Father')
    );
};
const evalbiologicalFamilyConditionFatherCancerGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFather.value.includes('Cancer')
    );
};
const evalbiologicalFamilyConditionFatherCancerDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherCancerGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFatherCancerDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionFatherHeartDiseaseGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFather.value.includes('HeartDisease')
    );
};
const evalbiologicalFamilyConditionFatherHeartDiseaseDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherHeartDiseaseGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFatherHeartDiseaseDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionFatherDiabetesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFather.value.includes('Diabetes')
    );
};
const evalbiologicalFamilyConditionFatherDiabetesDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherDiabetesGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFatherDiabetesDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionFatherStrokeGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFather.value.includes('Stroke')
    );
};
const evalbiologicalFamilyConditionFatherStrokeDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionFatherStrokeGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionFatherStrokeDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionMotherGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionWhichMember.value.includes('Mother')
    );
};
const evalbiologicalFamilyConditionMotherCancerGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMother.value.includes('Cancer')
    );
};
const evalbiologicalFamilyConditionMotherCancerDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherCancerGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMotherCancerDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionMotherHeartDiseaseGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMother.value.includes('HeartDisease')
    );
};
const evalbiologicalFamilyConditionMotherHeartDiseaseDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherHeartDiseaseGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMotherHeartDiseaseDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionMotherDiabetesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMother.value.includes('Diabetes')
    );
};
const evalbiologicalFamilyConditionMotherDiabetesDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherDiabetesGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMotherDiabetesDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionMotherStrokeGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMother.value.includes('Stroke')
    );
};
const evalbiologicalFamilyConditionMotherStrokeDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionMotherStrokeGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionMotherStrokeDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionBrotherGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionWhichMember.value.includes('Brother')
    );
};
const evalbiologicalFamilyConditionBrotherCancerGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrother.value.includes('Cancer')
    );
};
const evalbiologicalFamilyConditionBrotherCancerDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherCancerGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrotherCancerDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionBrotherHeartDiseaseGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrother.value.includes('HeartDisease')
    );
};
const evalbiologicalFamilyConditionBrotherHeartDiseaseDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherHeartDiseaseGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrotherHeartDiseaseDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionBrotherDiabetesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrother.value.includes('Diabetes')
    );
};
const evalbiologicalFamilyConditionBrotherDiabetesDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherDiabetesGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrotherDiabetesDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionBrotherStrokeGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrother.value.includes('Stroke')
    );
};
const evalbiologicalFamilyConditionBrotherStrokeDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionBrotherStrokeGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionBrotherStrokeDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionSisterGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionWhichMember.value.includes('Sister')
    );
};
const evalbiologicalFamilyConditionSisterCancerGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSister.value.includes('Cancer')
    );
};
const evalbiologicalFamilyConditionSisterCancerDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterCancerGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSisterCancerDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionSisterHeartDiseaseGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSister.value.includes('HeartDisease')
    );
};
const evalbiologicalFamilyConditionSisterHeartDiseaseDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterHeartDiseaseGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSisterHeartDiseaseDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionSisterDiabetesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSister.value.includes('Diabetes')
    );
};
const evalbiologicalFamilyConditionSisterDiabetesDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterDiabetesGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSisterDiabetesDied.value == 'Yes'
    );
};
const evalbiologicalFamilyConditionSisterStrokeGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSister.value.includes('Stroke')
    );
};
const evalbiologicalFamilyConditionSisterStrokeDiedYesGuard = (parameterStore: ParameterStore) => {
    return (
        evalbiologicalFamilyConditionSisterStrokeGuard(parameterStore) &&
        parameterStore.approval.biologicalFamilyConditionSisterStrokeDied.value == 'Yes'
    );
};
const evalspecialistVisitsYesGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.specialistVisits.value == 'Yes';
};
const evalstateNYGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.state.value == 'NY';
};
const evaltravelingOutGuard = (parameterStore: ParameterStore) => {
    return parameterStore.approval.travelingOut.value == true;
};

export const approvalGuards: {[key: string]: (parameterStore: ParameterStore) => boolean} = {
    policyOwnerName: evalsameOwnerNoGuard,
    ownerSocialSecurityNumber: evalsameOwnerNoGuard,
    ownerBMonth: evalsameOwnerNoGuard,
    ownerBday: evalsameOwnerNoGuard,
    ownerByear: evalsameOwnerNoGuard,
    ownerIssueState: evalsameOwnerNoAndFGGuard,
    ownerNumber: evalsameOwnerNoAndFGGuard,
    ownerCitizenshipCountry: evalsameOwnerNoAndFGOrMOOGuard,
    relationshipToInsured: evalsameOwnerNoGuard,
    policyOwnerPhone: evalsameOwnerNoGuard,
    policyOwnerEmail: evalsameOwnerNoAndLSWOrFGGuard,
    policyOwnerStreetAddress: evalsameOwnerNoGuard,
    policyOwnerCity: evalsameOwnerNoGuard,
    policyOwnerState: evalsameOwnerNoGuard,
    policyOwnerZipcode: evalsameOwnerNoGuard,
    currentSelfEmployed: evalcurrentlyEmployedEmployedGuard,
    nameOfEmployer: evalcurrentlyEmployedEmployedGuard,
    timeEmployed: evalcurrentlyEmployedEmployedGuard,
    employmentDays: evalcurrentlyEmployedEmployedGuard,
    employerAddress: evalcurrentlyEmployedEmployedGuard,
    occupation: evalcurrentlyEmployedEmployedGuard,
    industryDuties: evalcurrentlyEmployedEmployedGuard,
    prevSelfEmployed: evalprevEmployedGuard,
    prevEmployName: evalprevEmployedGuard,
    prevEmployStart: evalprevEmployedGuard,
    prevEmployOccup: evalprevEmployedGuard,
    prevEmployIndustry: evalprevEmployedGuard,
    reasonUnemployed: evalcurrentlyEmployedUnemployedGuard,
    previousJobInfo: evalcurrentlyEmployedUnemployedGuard,
    previousIncome: evalcurrentlyEmployedUnemployedGuard,
    retiredInfo: evalcurrentlyEmployedRetiredGuard,
    retiredIncome: evalcurrentlyEmployedRetiredGuard,
    schoolInfo: evalcurrentlyEmployedStudentGuard,
    disabilityInfo: evalcurrentlyEmployedDisabilityGuard,
    otherInfo: evalcurrentlyEmployedOtherGuard,
    usPermResNumber: evalusCitizenshipPermanentResidentGuard,
    usVisaType: evalusCitizenshipUSVisaHolderGuard,
    usVisaNumber: evalusCitizenshipUSVisaHolderGuard,
    usTinNumber: evalusCitizenshipNoUSVisaTINonlyGuard,
    ndiReason: evalvalidDriversLicenseNoIDGuard,
    driversLicenseState: evalvalidDriversLicenseYesGuard,
    driversLicenseNumber: evalvalidDriversLicenseYesGuard,
    driversLicExpiration: evalvalidDriversLicenseYesGuard,
    stateIdState: evalvalidDriversLicenseStateIDGuard,
    stateIdNumber: evalvalidDriversLicenseStateIDGuard,
    stateIdExpiration: evalvalidDriversLicenseStateIDGuard,
    noDriversLicenseReason: evalvalidDriversLicenseNotYesGuard,
    modeOfTransport: evalvalidDriversLicenseNotYesGuard,
    militaryServiceBranch: evalmilitaryYesGuard,
    militaryServieStatus: evalmilitaryYesGuard,
    militaryServePeriod: evalmilitaryYesGuard,
    beneInfo2: evalnumberOfBenesGt1Guard,
    benePercent2: evalnumberOfBenesGt1Guard,
    beneRelationship2: evalnumberOfBenesGt1Guard,
    beneMonth2: evalnumberOfBenesGt1Guard,
    beneDay2: evalnumberOfBenesGt1Guard,
    beneYear2: evalnumberOfBenesGt1Guard,
    beneInfo3: evalnumberOfBenesGt2Guard,
    benePercent3: evalnumberOfBenesGt2Guard,
    beneRelationship3: evalnumberOfBenesGt2Guard,
    beneMonth3: evalnumberOfBenesGt2Guard,
    beneDay3: evalnumberOfBenesGt2Guard,
    beneYear3: evalnumberOfBenesGt2Guard,
    beneInfo4: evalnumberOfBenesGt3Guard,
    benePercent4: evalnumberOfBenesGt3Guard,
    beneRelationship4: evalnumberOfBenesGt3Guard,
    beneMonth4: evalnumberOfBenesGt3Guard,
    beneDay4: evalnumberOfBenesGt3Guard,
    beneYear4: evalnumberOfBenesGt3Guard,
    beneInfo5: evalnumberOfBenesGt4Guard,
    benePercent5: evalnumberOfBenesGt4Guard,
    beneRelationship5: evalnumberOfBenesGt4Guard,
    beneMonth5: evalnumberOfBenesGt4Guard,
    beneDay5: evalnumberOfBenesGt4Guard,
    beneYear5: evalnumberOfBenesGt4Guard,
    beneInfo6: evalnumberOfBenesGt5Guard,
    benePercent6: evalnumberOfBenesGt5Guard,
    beneRelationship6: evalnumberOfBenesGt5Guard,
    beneMonth6: evalnumberOfBenesGt5Guard,
    beneDay6: evalnumberOfBenesGt5Guard,
    beneYear6: evalnumberOfBenesGt5Guard,
    beneTotalPercent: evalbeneTotalPctGuard,
    contNumberOfBenes: evalcontBeneYesGuard,
    contBeneInfo1: evalcontBeneYesGuard,
    contBenePercent1: evalcontBeneYesGuard,
    contBeneRelationship1: evalcontBeneYesGuard,
    contBeneMonth1: evalcontBeneYesGuard,
    contBday1: evalcontBeneYesGuard,
    contBeneYear1: evalcontBeneYesGuard,
    contBeneInfo2: evalcalculatedContNumberOfBenesGt1Guard,
    contBenePercent2: evalcalculatedContNumberOfBenesGt1Guard,
    contBeneRelationship2: evalcalculatedContNumberOfBenesGt1Guard,
    contBeneMonth2: evalcalculatedContNumberOfBenesGt1Guard,
    contBday2: evalcalculatedContNumberOfBenesGt1Guard,
    contBeneYear2: evalcalculatedContNumberOfBenesGt1Guard,
    contBeneInfo3: evalcalculatedContNumberOfBenesGt2Guard,
    contBenePercent3: evalcalculatedContNumberOfBenesGt2Guard,
    contBeneRelationship3: evalcalculatedContNumberOfBenesGt2Guard,
    contBeneMonth3: evalcalculatedContNumberOfBenesGt2Guard,
    contBday3: evalcalculatedContNumberOfBenesGt2Guard,
    contBeneYear3: evalcalculatedContNumberOfBenesGt2Guard,
    contBeneInfo4: evalcalculatedContNumberOfBenesGt3Guard,
    contBenePercent4: evalcalculatedContNumberOfBenesGt3Guard,
    contBeneRelationship4: evalcalculatedContNumberOfBenesGt3Guard,
    contBeneMonth4: evalcalculatedContNumberOfBenesGt3Guard,
    contBday4: evalcalculatedContNumberOfBenesGt3Guard,
    contBeneYear4: evalcalculatedContNumberOfBenesGt3Guard,
    contBeneInfo5: evalcalculatedContNumberOfBenesGt4Guard,
    contBenePercent5: evalcalculatedContNumberOfBenesGt4Guard,
    contBeneRelationship5: evalcalculatedContNumberOfBenesGt4Guard,
    contBeneMonth5: evalcalculatedContNumberOfBenesGt4Guard,
    contBday5: evalcalculatedContNumberOfBenesGt4Guard,
    contBeneYear5: evalcalculatedContNumberOfBenesGt4Guard,
    contBeneInfo6: evalcalculatedContNumberOfBenesGt5Guard,
    contBenePercent6: evalcalculatedContNumberOfBenesGt5Guard,
    contBeneRelationship6: evalcalculatedContNumberOfBenesGt5Guard,
    contBeneMonth6: evalcalculatedContNumberOfBenesGt5Guard,
    contBday6: evalcalculatedContNumberOfBenesGt5Guard,
    contBeneYear6: evalcalculatedContNumberOfBenesGt5Guard,
    contBeneTotalPercent: evalcontBeneTotalPctGuard,
    existingCarrier: evalexistingCoverageYesGuard,
    existingPolicyType: evalexistingCoverageYesGuard,
    existingCoverageAmount: evalexistingCoverageYesGuard,
    replacingExistingPolicy: evalexistingCoverageYesGuard,
    shoppedCarrier: evalshoppedCoverageYesGuard,
    shoppedPolicyType: evalshoppedCoverageYesGuard,
    shoppedCoverageAmount: evalshoppedCoverageYesGuard,
    alcoholDiagnosisDate: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholTreatment: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholTreatmentDetails: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholTreatmentDate: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholTreatmentClinic: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholDrugFree: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholBeverages: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholDrinkType: evalDrugorAlcoholDependenceWithdrawalGuard,
    weeklyAlcoholicDrinks: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholDrinks: evalDrugorAlcoholDependenceWithdrawalGuard,
    alcoholMember: evalDrugorAlcoholDependenceWithdrawalGuard,
    DrugOrAlcoholTreatmentDetailsNotes: evalDrugorAlcoholDependenceWithdrawalGuard,
    typeOfDrug: evalDrugorAlcoholDependenceWithdrawalGuard,
    takingMedicineDueToDrug: evalDrugorAlcoholDependenceWithdrawalGuard,
    medicineNameDueToDrug: evalDrugorAlcoholDependenceWithdrawalANDtakingMedicineDueToDrugGuard,
    DUIDate: evalDUIGuard,
    duiDate: evalDUIGuard,
    duiNotes: evalDUIGuard,
    suspendedLicenseDate: evalLicenseGuard,
    suspendedLicense: evalLicenseGuard,
    licenseNotes: evalLicenseGuard,
    violationNumbers: evalMovingviolationsGuard,
    movingViolationsNotes: evalMovingviolationsGuard,
    criminalOffenseChargeType: evalCriminaloffenseGuard,
    criminalOffenseType: evalCriminaloffenseGuard,
    criminalOffenseIncarcerated: evalCriminaloffenseGuard,
    criminalOffenseIncarcerationYear: evalCriminaloffenseANDcriminalOffenseIncarceratedGuard,
    criminalOffenseIncarcerationYearOut: evalCriminaloffenseANDcriminalOffenseIncarceratedGuard,
    criminalOffenseProbation: evalCriminaloffenseANDcriminalOffenseIncarceratedGuard,
    criminalOffenseDetails: evalCriminaloffenseGuard,
    criminalOffenseDate: evalCriminaloffenseGuard,
    criminalParole: evalCriminaloffenseGuard,
    criminalOffenseNotes: evalCriminaloffenseGuard,
    bankruptcyYear: evalBankruptcyGuard,
    bankruptcyChapter: evalBankruptcyGuard,
    bankruptcyOpen: evalBankruptcyGuard,
    bankruptcyDischargeDate: evalBankruptcyANDNotbankruptcyOpenGuard,
    bankruptcyNotes: evalBankruptcyGuard,
    bankruptcyMultiple: evalBankruptcyGuard,
    bankruptcyMultipleDetail: evalbankruptcyMultipleGuard,
    extremeSportsOptions: evalextremeSportsYesGuard,
    extremeSportsScubaType: evalextremeSportsScubaDivingGuard,
    extremeSportsScubaDepth: evalextremeSportsScubaDivingGuard,
    tobaccoProducts: evalTobaccoRatingYesGuard,
    tobaccoFrequency: evalTobaccoRatingYesGuard,
    tobaccoLastUse: evalTobaccoRatingYesGuard,
    marijuanaProducts: evalMarijuanaRatingGuard,
    marijuanaFrequency: evalMarijuanaRatingGuard,
    marijuanaLastUse: evalMarijuanaRatingGuard,
    otherSubstance: evalOtherRatingGuard,
    otherProducts: evalOtherRatingGuard,
    otherFrequency: evalOtherRatingGuard,
    otherLastUse: evalOtherRatingGuard,
    fatherAge: evalfatherLivingYesGuard,
    fatherPassingAge: evalfatherLivingNoGuard,
    fatherPassingCause: evalfatherLivingNoGuard,
    fatherUnknown: evalfatherLivingUnknownGuard,
    motherAge: evalmotherLivingYesGuard,
    motherPassingAge: evalmotherLivingNoGuard,
    motherPassingCause: evalmotherLivingNoGuard,
    motherUnknown: evalmotherLivingUnknownGuard,
    biologicalFamilyConditionWhichMember: evalbiologicalFamilyConditionGuard,
    biologicalFamilyConditionFather: evalbiologicalFamilyConditionFatherGuard,
    biologicalFamilyConditionFatherCancerDiagnosedAge: evalbiologicalFamilyConditionFatherCancerGuard,
    biologicalFamilyConditionFatherCancerDied: evalbiologicalFamilyConditionFatherCancerGuard,
    biologicalFamilyConditionFatherCancerDiedAge: evalbiologicalFamilyConditionFatherCancerDiedYesGuard,
    biologicalFamilyConditionFatherCancerType: evalbiologicalFamilyConditionFatherCancerGuard,
    biologicalFamilyConditionFatherHeartDiseaseAge: evalbiologicalFamilyConditionFatherHeartDiseaseGuard,
    biologicalFamilyConditionFatherHeartDiseaseDied: evalbiologicalFamilyConditionFatherHeartDiseaseGuard,
    biologicalFamilyConditionFatherHeartDiseaseDiedAgee: evalbiologicalFamilyConditionFatherHeartDiseaseDiedYesGuard,
    biologicalFamilyConditionFatherDiabetesAge: evalbiologicalFamilyConditionFatherDiabetesGuard,
    biologicalFamilyConditionFatherDiabetesDied: evalbiologicalFamilyConditionFatherDiabetesGuard,
    biologicalFamilyConditionFatherDiabetesDiedAgee: evalbiologicalFamilyConditionFatherDiabetesDiedYesGuard,
    biologicalFamilyConditionFatherStrokeAge: evalbiologicalFamilyConditionFatherStrokeGuard,
    biologicalFamilyConditionFatherStrokeDied: evalbiologicalFamilyConditionFatherStrokeGuard,
    biologicalFamilyConditionFatherStrokeDiedAgee: evalbiologicalFamilyConditionFatherStrokeDiedYesGuard,
    biologicalFamilyConditionMother: evalbiologicalFamilyConditionMotherGuard,
    biologicalFamilyConditionMotherCancerDiagnosedAge: evalbiologicalFamilyConditionMotherCancerGuard,
    biologicalFamilyConditionMotherCancerDied: evalbiologicalFamilyConditionMotherCancerGuard,
    biologicalFamilyConditionMotherCancerDiedAge: evalbiologicalFamilyConditionMotherCancerDiedYesGuard,
    biologicalFamilyConditionMotherCancerType: evalbiologicalFamilyConditionMotherCancerGuard,
    biologicalFamilyConditionMotherHeartDiseaseAge: evalbiologicalFamilyConditionMotherHeartDiseaseGuard,
    biologicalFamilyConditionMotherHeartDiseaseDied: evalbiologicalFamilyConditionMotherHeartDiseaseGuard,
    biologicalFamilyConditionMotherHeartDiseaseDiedAgee: evalbiologicalFamilyConditionMotherHeartDiseaseDiedYesGuard,
    biologicalFamilyConditionMotherDiabetesAge: evalbiologicalFamilyConditionMotherDiabetesGuard,
    biologicalFamilyConditionMotherDiabetesDied: evalbiologicalFamilyConditionMotherDiabetesGuard,
    biologicalFamilyConditionMotherDiabetesDiedAgee: evalbiologicalFamilyConditionMotherDiabetesDiedYesGuard,
    biologicalFamilyConditionMotherStrokeAge: evalbiologicalFamilyConditionMotherStrokeGuard,
    biologicalFamilyConditionMotherStrokeDied: evalbiologicalFamilyConditionMotherStrokeGuard,
    biologicalFamilyConditionMotherStrokeDiedAgee: evalbiologicalFamilyConditionMotherStrokeDiedYesGuard,
    biologicalFamilyConditionBrother: evalbiologicalFamilyConditionBrotherGuard,
    biologicalFamilyConditionBrotherCancerDiagnosedAge: evalbiologicalFamilyConditionBrotherCancerGuard,
    biologicalFamilyConditionBrotherCancerDied: evalbiologicalFamilyConditionBrotherCancerGuard,
    biologicalFamilyConditionBrotherCancerDiedAge: evalbiologicalFamilyConditionBrotherCancerDiedYesGuard,
    biologicalFamilyConditionBrotherCancerType: evalbiologicalFamilyConditionBrotherCancerGuard,
    biologicalFamilyConditionBrotherHeartDiseaseAge: evalbiologicalFamilyConditionBrotherHeartDiseaseGuard,
    biologicalFamilyConditionBrotherHeartDiseaseDied: evalbiologicalFamilyConditionBrotherHeartDiseaseGuard,
    biologicalFamilyConditionBrotherHeartDiseaseDiedAgee: evalbiologicalFamilyConditionBrotherHeartDiseaseDiedYesGuard,
    biologicalFamilyConditionBrotherDiabetesAge: evalbiologicalFamilyConditionBrotherDiabetesGuard,
    biologicalFamilyConditionBrotherDiabetesDied: evalbiologicalFamilyConditionBrotherDiabetesGuard,
    biologicalFamilyConditionBrotherDiabetesDiedAgee: evalbiologicalFamilyConditionBrotherDiabetesDiedYesGuard,
    biologicalFamilyConditionBrotherStrokeAge: evalbiologicalFamilyConditionBrotherStrokeGuard,
    biologicalFamilyConditionBrotherStrokeDied: evalbiologicalFamilyConditionBrotherStrokeGuard,
    biologicalFamilyConditionBrotherStrokeDiedAgee: evalbiologicalFamilyConditionBrotherStrokeDiedYesGuard,
    biologicalFamilyConditionSister: evalbiologicalFamilyConditionSisterGuard,
    biologicalFamilyConditionSisterCancerDiagnosedAge: evalbiologicalFamilyConditionSisterCancerGuard,
    biologicalFamilyConditionSisterCancerDied: evalbiologicalFamilyConditionSisterCancerGuard,
    biologicalFamilyConditionSisterCancerDiedAge: evalbiologicalFamilyConditionSisterCancerDiedYesGuard,
    biologicalFamilyConditionSisterCancerType: evalbiologicalFamilyConditionSisterCancerGuard,
    biologicalFamilyConditionSisterHeartDiseaseAge: evalbiologicalFamilyConditionSisterHeartDiseaseGuard,
    biologicalFamilyConditionSisterHeartDiseaseDied: evalbiologicalFamilyConditionSisterHeartDiseaseGuard,
    biologicalFamilyConditionSisterHeartDiseaseDiedAgee: evalbiologicalFamilyConditionSisterHeartDiseaseDiedYesGuard,
    biologicalFamilyConditionSisterDiabetesAge: evalbiologicalFamilyConditionSisterDiabetesGuard,
    biologicalFamilyConditionSisterDiabetesDied: evalbiologicalFamilyConditionSisterDiabetesGuard,
    biologicalFamilyConditionSisterDiabetesDiedAgee: evalbiologicalFamilyConditionSisterDiabetesDiedYesGuard,
    biologicalFamilyConditionSisterStrokeAge: evalbiologicalFamilyConditionSisterStrokeGuard,
    biologicalFamilyConditionSisterStrokeDied: evalbiologicalFamilyConditionSisterStrokeGuard,
    biologicalFamilyConditionSisterStrokeDiedAgee: evalbiologicalFamilyConditionSisterStrokeDiedYesGuard,
    specialistName: evalspecialistVisitsYesGuard,
    nyIllustrationSigned: evalstateNYGuard,
    travelingPlace: evaltravelingOutGuard,
    travelDuration: evaltravelingOutGuard,
    travelReason: evaltravelingOutGuard,
    travelDates: evaltravelingOutGuard,
};
